/* eslint-disable @typescript-eslint/no-use-before-define */

/**
 * Returns `true` if all target keys exist on current
 *
 * @param current Object
 * @param target Object
 * @returns boolean
 */
export function objectIncludes(current: HashAny, target: HashAny): boolean {
  return Object.keys(target).every(key => key in current);
}

/**
 * Returns `true` is both objects have the same keys and their values match.
 *
 * Does a shallow match, using [equalsMatcher].
 *
 * @param objA Object
 * @param objB Object
 * @returns boolean
 */
export function objectsMatch(
  objA: HashAny,
  objB: HashAny,
  matcher = equalsMatcher,
): boolean {
  const currentKeys = Object.keys(objA);
  const targetKeys = Object.keys(objB);
  return (
    currentKeys.length === targetKeys.length &&
    targetKeys.every(key => matcher(objA[key], objB[key]))
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function equalsMatcher(a: any, b: any): boolean {
  return a === b;
}
